var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticStyle:{"width":"80%"},attrs:{"fluid":""}},[_c('v-tabs',[_c('v-tab',{on:{"click":function($event){_vm.incoming = true;
          _vm.cancelled = false;}}},[_vm._v("Incoming")]),_c('v-tab',{on:{"click":function($event){_vm.cancelled = true;
          _vm.incoming = false;}}},[_vm._v("Cancelled")])],1),(_vm.incoming)?_c('incTab'):_vm._e(),(_vm.cancelled)?_c('cancTab'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }